import Section, { size } from '../../generic/Section';

import BundleCard from '../BundleCard';
import React from 'react';
import styles from './index.module.scss';

export default function WorkspaceProducts({ bundles = [] }) {
  if (!bundles) {
    return null;
  }
  return (
    <Section size={size.max} className={styles.workspaceProducts}>
      <h4 className={styles.header}>Products in this room</h4>
      {bundles.map((bundle, index) => (
        <BundleCard bundle={bundle} key={index} className={styles.bundleCard} />
      ))}
    </Section>
  );
}
